import styles from './TermsButton.module.scss';

import Link from 'next/link';

import useConfig from '@/hooks/useConfig';

interface ITermsButtonProps {
  withFillerText?: boolean;
}

export default function TermsButton(props: ITermsButtonProps) {
  const { t } = useConfig();

  return (
    <section className={styles.buttonContainer}>
      {props.withFillerText && <p><strong>{t('common.tos-notice.filler')}</strong></p>}
      <Link href="/terms-of-service">
        <button className="read">{ t('common.tos-notice.button') }</button>
      </Link>
    </section>
  );
}
